export const checkIsGmailRegxp = new RegExp(/@gmail.com$/);
export const prefixIsUsdtRegxp = new RegExp(/^usdt/);
export const randomSeedValueRegxp = new RegExp(/_.+/);
